import React from 'react'
import BaseIcon from './BaseIcon'

/*eslint-disable */
export default class Phone extends BaseIcon {
  static defaultProps = {
    width: 15,
    height: 15,
    viewBox: '58 101 15 15'
  }
  render () {
    return (
      <svg {...this.getSvgProps()}>
        <path d='M70.64 115.256c.33-.37.7-.705 1.05-1.058.518-.523.522-1.157.007-1.676-.615-.62-1.23-1.235-1.85-1.85-.507-.5-1.14-.5-1.646 0-.383.382-.77.763-1.146 1.153-.026.027-.05.05-.076.064l-.264.262c-.074.047-.147.046-.242-.005-.248-.135-.513-.245-.752-.395-1.116-.7-2.052-1.604-2.88-2.62-.41-.507-.777-1.045-1.03-1.653-.043-.103-.044-.175.013-.25l.264-.266c.013-.017.027-.035.046-.052l.344-.337c.267-.265.53-.532.795-.798.526-.53.525-1.152-.004-1.686-.3-.302-.602-.602-.904-.903-.31-.31-.618-.624-.932-.93-.507-.5-1.14-.5-1.648-.003-.386.38-.76.774-1.153 1.148-.366.348-.552.77-.59 1.267-.06.803.137 1.563.413 2.305.57 1.535 1.437 2.895 2.487 4.143 1.417 1.688 3.114 3.025 5.098 3.99.892.432 1.82.766 2.824.82.69.04 1.295-.135 1.777-.674z'
          {...this.getPathProps()} />
      </svg>
    )
  }
}
/*eslint-enable */
